<template>
<figure class="image" :class="classArray">
  <slot></slot>
  <img :src="src" :alt="alt" :class="{ 'is-rounded': isRounded, 'backgrounded': hasBackground }">
</figure>
</template>

<script>
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: 'is-96x96'
    },
    isRounded: {
      type: Boolean,
      default: true
    },
    alt: {
      type: String,
      default: ''
    },
    isCentered: {
      type: Boolean,
      default: false
    },
    hasBackground: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classArray () {
      return [
        this.size,
        { 'is-centered': this.isCentered }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
  height: 100%;
}

img.backgrounded {
  background-color: white;
}

.image.is-40x40 {
  height: 40px;
  width: 40px;
}

.image.is-60x60 {
  height: 60px;
  width: 60px;
}
@media (max-width: 769px) {
  .image.is-40x40 {
    height: 40px;
    width: 40px;
  }

  .image.is-60x60 {
    height: 40px;
    width: 40px;
  }
}

@media (max-width: 600px) {
  .image.is-40x40 {
    height: 40px;
    width: 40px;
  }

  .image.is-60x60 {
    height: 30px;
    width: 30px;
  }
}

.navbar-item img {
  max-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/general/image.vue